<template>
  <footer class="trapezoid">
    <div class="footer-contact mat1x-fire-intro-main-width">
      <div class="footer-logo">
        <svg-icon icon-class="block_logo" class-name="block-logo-svg"
          :style="{ width: '165px', height: '48px', stroke: 'white', color: 'white' }"></svg-icon>
      </div>
      <ul>
        <li v-for="link in mediaJson.links" :key="link.name">
          <a :href="link.link" :class="[`link-${link.name}`]" target="_blank">
            <svg-icon :icon-class="link.name" class-name="link-svg"></svg-icon>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import mediaJson from "@/components/common/json/link.json";
export default {
  components: {},
  props: {},
  data() {
    return {
      mediaJson
    }
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>